// Copyright Square, Inc.
export var userJourneyEventMonitors = [
    {
        journeyName: "add-money",
        cdfEvent: "CashDepositStart",
        requiredParameters: {},
        trigger: { type: 'entry' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "CashDepositEnterAmount",
        requiredParameters: {
            "enter_method": "SELECTED",
        },
        trigger: { type: 'variant', variantName: 'Selected' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "CashDepositEnterAmount",
        requiredParameters: {
            "enter_method": "KEYPAD",
        },
        trigger: { type: 'variant', variantName: 'Keypad' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "passcode_verification",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'passcode-verification' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "InstrumentSelectionBlocker",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'instrument-selection' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "provide_ssn",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'provide-ssn' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "eidv_introduction",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'eidv-introduction' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "PERSONA_DIDV",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'didv' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "verify_ssn_blocker",
        },
        trigger: { type: 'friction', signalName: 'tax_id_verify_ssn' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "CASH_TAX_IDENTITY_W9_CONSENT_BLOCKER",
        },
        trigger: { type: 'friction', signalName: 'tax_id_w9_consent' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "CASH_TAX_IDENTITY_W9_BACKUP_WITHHOLDING_BLOCKER",
        },
        trigger: { type: 'friction', signalName: 'tax_id_w9_backup_withholding' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "CashTaxIdentityIncorrectInformationBlocker",
        },
        trigger: { type: 'friction', signalName: 'tax_id_incorrect_information' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "FLOW_TERMINATION",
        },
        trigger: { type: 'friction', signalName: 'unspecified_termination_blocker' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "MARKET_SELL_SUCCESS",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "CashTaxIdentityIncorrectInformationBlocker",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "FLOW_TERMINATION",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "eidv_introduction",
        },
        trigger: { type: 'variant', variantName: 'EIDV' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "PERSONA_DIDV",
        },
        trigger: { type: 'variant', variantName: 'DIDV' }
    },
    {
        journeyName: "login",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "accountRecoveryFailureBlocker",
        },
        trigger: { type: 'friction', signalName: 'account-recovery-failed' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "TRANSFER_OPTION_SELECTION_BLOCKER_ID_DEPOSIT_TO",
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
        },
        trigger: { type: 'variant', variantName: 'from-savings-home' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "TRANSFER_OPTION_SELECTION_BLOCKER_ID_ADD_MONEY_FROM",
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
        },
        trigger: { type: 'variant', variantName: 'from-sub-balance' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "card_blocker",
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
        },
        trigger: { type: 'variant', variantName: 'with-card-linking' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "confirm.requires_passcode",
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
        },
        trigger: { type: 'variant', variantName: 'with-pin-verification' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "TRANSFER_OPTION_SELECTION_BLOCKER_ID_ADD_MONEY_FROM",
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
        },
        trigger: { type: 'friction', signalName: 'source-selection' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "TRANSFER_OPTION_SELECTION_BLOCKER_ID_DEPOSIT_TO",
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
        },
        trigger: { type: 'friction', signalName: 'destination-selection' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "card_blocker",
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
        },
        trigger: { type: 'friction', signalName: 'card-linking' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "SAVINGS_TRANSFER_AMOUNT_SELECTION_FORM",
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
        },
        trigger: { type: 'friction', signalName: 'amount-selection' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "TRANSACTION_EDIT_AND_CONFIRM_BLOCKER",
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
        },
        trigger: { type: 'friction', signalName: 'transaction-confirmation' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "confirm.requires_passcode",
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
        },
        trigger: { type: 'friction', signalName: 'pin-verification' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "TRANSFER_OPTION_SELECTION_BLOCKER_ID_WITHDRAW_FROM",
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
        },
        trigger: { type: 'variant', variantName: 'from-savings-home' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "TRANSFER_OPTION_SELECTION_BLOCKER_ID_DEPOSIT_TO",
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
        },
        trigger: { type: 'variant', variantName: 'from-sub-balance' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "confirm.requires_passcode",
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
        },
        trigger: { type: 'variant', variantName: 'with-pin-verification' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "TRANSFER_OPTION_SELECTION_BLOCKER_ID_WITHDRAW_FROM",
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
        },
        trigger: { type: 'friction', signalName: 'transfer-option-selection-withdraw-from' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "TRANSFER_OPTION_SELECTION_BLOCKER_ID_DEPOSIT_TO",
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
        },
        trigger: { type: 'friction', signalName: 'transfer-option-selection-deposit-to' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "SAVINGS_TRANSFER_AMOUNT_SELECTION_FORM",
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
        },
        trigger: { type: 'friction', signalName: 'amount-selection' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "TRANSACTION_EDIT_AND_CONFIRM_BLOCKER",
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
        },
        trigger: { type: 'friction', signalName: 'transaction-confirmation' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "confirm.requires_passcode",
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
        },
        trigger: { type: 'friction', signalName: 'pin-verification' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "verify_ssn_blocker",
        },
        trigger: { type: 'friction', signalName: 'stock_buy_id_verify_ssn' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "confirm.requires_passcode",
        },
        trigger: { type: 'friction', signalName: 'stock_buy_confirm_passcode' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "CASH_TAX_IDENTITY_W9_CONSENT_BLOCKER",
        },
        trigger: { type: 'friction', signalName: 'stock_buy_tax_id_w9_consent' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "AGREEMENTS_BLOCKER_DESCRIPTOR_ID",
        },
        trigger: { type: 'friction', signalName: 'stock_buy_agreements' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "EMPLOYMENT_STATUS_BLOCKER_DESCRIPTOR_ID",
        },
        trigger: { type: 'friction', signalName: 'stock_buy_employment_status' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "ADD_NEW_EMAIL_OR_PHONE_NUMBER_BLOCKER_ID",
        },
        trigger: { type: 'friction', signalName: 'stock_buy_add_email_or_phone_number' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "invest_equity_term_of_conditions",
        },
        trigger: { type: 'friction', signalName: 'stock_buy_term_of_conditions' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "FLOW_TERMINATION",
        },
        trigger: { type: 'friction', signalName: 'unspecified_termination_blocker' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "verify_ssn_blocker",
        },
        trigger: { type: 'friction', signalName: 'stock_sale_id_verify_ssn' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "FLOW_TERMINATION",
        },
        trigger: { type: 'friction', signalName: 'unspecified_termination_blocker' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "passcode_verification",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'passcode-verification' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "InstrumentSelectionBlocker",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'instrument-selection' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "provide_ssn",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'provide-ssn' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "eidv_introduction",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'eidv-introduction' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "PERSONA_DIDV",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'friction', signalName: 'didv' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "standardCashOutConfirmedBlocker",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractViewBlocker",
        requiredParameters: {
            "blocker_id": "instantCashOutDomainApiConfirmedBlocker",
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "IDENTITY_HUB",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "IDENTITY_HUB",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "IDENTITY_HUB",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "EXCHANGE_EQUITY",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "EXCHANGE_EQUITY",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "EXCHANGE_EQUITY",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "EXCHANGE_EQUITY",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "EXCHANGE_EQUITY",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "EXCHANGE_EQUITY",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
            "outcome": "JOURNEY_OUTCOME_SUCCEEDED",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
            "outcome": "JOURNEY_OUTCOME_FAILED",
        },
        trigger: { type: 'exit', outcome: 'failed' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractReceiveJourneyOutcome",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
            "outcome": "JOURNEY_OUTCOME_USER_CANCELED",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "CashDepositCanceled",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "add-money",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {
            "client_scenario": "IDENTITY_HUB",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
            "originating_flow_type": "ADD_MONEY_TO_SAVINGS_BALANCE",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
            "originating_flow_type": "WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {
            "client_scenario": "PAYMENT_FLOW",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {
            "client_scenario": "EXCHANGE_EQUITY",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {
            "client_scenario": "EXCHANGE_EQUITY",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "BlockerFlowInteractCancelFlow",
        requiredParameters: {
            "client_scenario": "TRANSFER_FUNDS",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "CryptoTradeStart",
        requiredParameters: {
            "side": "SELL",
            "source_asset": "btc",
        },
        trigger: { type: 'entry' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractTapBlockerAction",
        requiredParameters: {
            "blocker_id": "CASH_TAX_IDENTITY_W9_CONSENT_BLOCKER",
            "blocker_action": "INTERNAL_NAVIGATION_ACTION",
        },
        trigger: { type: 'friction', signalName: 'tax_id_navigate_to_edit_personal_information' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "BlockerFlowInteractTapBlockerAction",
        requiredParameters: {
            "blocker_id": "CASH_TAX_IDENTITY_W9_CONSENT_BLOCKER",
            "blocker_action": "INTERNAL_NAVIGATION_ACTION",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "login",
        cdfEvent: "BlockerFlowInteractTapBlockerAction",
        requiredParameters: {
            "action_text": "Help",
            "blocker_id": "FACTOR_SELECTION",
        },
        trigger: { type: 'friction', signalName: 'required-help' }
    },
    {
        journeyName: "login",
        cdfEvent: "BlockerFlowInteractTapBlockerAction",
        requiredParameters: {
            "action_text": "I don't have any of these",
            "blocker_id": "FACTOR_SELECTION",
        },
        trigger: { type: 'friction', signalName: 'required-help' }
    },
    {
        journeyName: "login",
        cdfEvent: "BlockerFlowInteractTapBlockerAction",
        requiredParameters: {
            "action_text": "I don't have any of these",
            "action_id": "OPEN_URL_ACTION",
        },
        trigger: { type: 'friction', signalName: 'account-recovery-required-help' }
    },
    {
        journeyName: "login",
        cdfEvent: "BlockerFlowInteractTapBlockerAction",
        requiredParameters: {
            "client_scenario": "RECOVER_ALIAS_ACCOUNT",
            "blocker_action": "SIGN_OUT_ACTION",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "login",
        cdfEvent: "BlockerFlowInteractTapBlockerAction",
        requiredParameters: {
            "client_scenario": "ONBOARDING",
            "blocker_action": "SIGN_OUT_ACTION",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "CryptoTradeClose",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "CryptoTradeComplete",
        requiredParameters: {
            "order_type": "STANDARD",
        },
        trigger: { type: 'tag', tagName: 'market-order' }
    },
    {
        journeyName: "bitcoin-sell",
        cdfEvent: "CryptoTradeComplete",
        requiredParameters: {
            "order_type": "LIMIT",
        },
        trigger: { type: 'tag', tagName: 'limit-order' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "IdentityOpenView",
        requiredParameters: {
            "screen_type": "IdentityHub",
        },
        trigger: { type: 'entry' }
    },
    {
        journeyName: "identity-verification",
        cdfEvent: "BlockerFlowInteractViewBlockerResponse",
        requiredParameters: {
            "client_scenario": "IDENTITY_HUB",
            "blocker_id": "IDV_END_RESULT",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "login",
        cdfEvent: "BlockerFlowInteractViewBlockerResponse",
        requiredParameters: {
            "blocker_id": "email_verification",
            "error_code": "INVALID_VERIFICATION_CODE",
        },
        trigger: { type: 'friction', signalName: 'account-verify-error' }
    },
    {
        journeyName: "login",
        cdfEvent: "BlockerFlowInteractViewBlockerResponse",
        requiredParameters: {
            "blocker_id": "phone_verification",
            "error_code": "INVALID_VERIFICATION_CODE",
        },
        trigger: { type: 'friction', signalName: 'account-verify-error' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractViewBlockerResponse",
        requiredParameters: {
            "blocker_id": "confirm.requires_passcode",
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
            "error_code": "INVALID_PASSCODE",
        },
        trigger: { type: 'friction', signalName: 'pin-failure' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractViewBlockerResponse",
        requiredParameters: {
            "blocker_id": "confirm.requires_passcode",
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
            "error_code": "INVALID_PASSCODE",
        },
        trigger: { type: 'friction', signalName: 'pin-failure' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractViewBlockerResponse",
        requiredParameters: {
            "blocker_id": "confirm.requires_passcode",
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
            "error_code": "TOO_MANY_ATTEMPTS",
        },
        trigger: { type: 'friction', signalName: 'pin-blocked' }
    },
    {
        journeyName: "login",
        cdfEvent: "AccountSignInRequireHelp",
        requiredParameters: {},
        trigger: { type: 'friction', signalName: 'required-help' }
    },
    {
        journeyName: "login",
        cdfEvent: "AliasVerifyRequireHelp",
        requiredParameters: {},
        trigger: { type: 'friction', signalName: 'required-help' }
    },
    {
        journeyName: "login",
        cdfEvent: "AccountRecoveryStart",
        requiredParameters: {},
        trigger: { type: 'friction', signalName: 'account-recovery-started' }
    },
    {
        journeyName: "login",
        cdfEvent: "AliasVerifyReceiveError",
        requiredParameters: {
            "error_type": "TOO_MANY_FAILED_ATTEMPTS",
        },
        trigger: { type: 'friction', signalName: 'account-verify-failed' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {},
        trigger: { type: 'entry' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "PROFILE_DIRECTORY",
        },
        trigger: { type: 'variant', variantName: 'discover' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "CUSTOMER_PROFILE_ACTIVITY",
        },
        trigger: { type: 'variant', variantName: 'customer-profile-activity' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "CUSTOMER_PROFILE_PROFILE_DIRECTORY",
        },
        trigger: { type: 'variant', variantName: 'customer-profile-discover' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "CUSTOMER_PROFILE_FAVORITES",
        },
        trigger: { type: 'variant', variantName: 'customer-profile-favorites' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "APP_LINK",
        },
        trigger: { type: 'variant', variantName: 'client-route' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "APP_SHORTCUT",
        },
        trigger: { type: 'variant', variantName: 'app-shortcut' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "SIRI_DRAFT_PAYMENT",
        },
        trigger: { type: 'variant', variantName: 'siri' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "AssetRequestStart",
        requiredParameters: {
            "origin": "AMOUNT_FIRST",
        },
        trigger: { type: 'variant', variantName: 'amount-first' }
    },
    {
        journeyName: "request-money",
        cdfEvent: "CashRequestCancel",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "SavingsFolderTransferInStart",
        requiredParameters: {
            "cdf_action": "TransferIn",
            "origin": "SAVINGS_HOME",
        },
        trigger: { type: 'entry' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "SavingsFolderTransferInStart",
        requiredParameters: {
            "cdf_action": "TransferIn",
            "origin": "SAVINGS_SUB_BALANCE",
        },
        trigger: { type: 'entry' }
    },
    {
        journeyName: "savings-transfer-in",
        cdfEvent: "BlockerFlowInteractCompleteFlow",
        requiredParameters: {
            "client_scenario": "PLASMA_ADD_MONEY_TO_SAVINGS_BALANCE",
            "originating_flow_type": "ADD_MONEY_TO_SAVINGS_BALANCE",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "BlockerFlowInteractCompleteFlow",
        requiredParameters: {
            "client_scenario": "PLASMA_WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
            "originating_flow_type": "WITHDRAW_MONEY_FROM_SAVINGS_BALANCE",
        },
        trigger: { type: 'exit', outcome: 'succeeded' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "SavingsFolderTransferOutStart",
        requiredParameters: {
            "cdf_action": "TransferOut",
            "origin": "SAVINGS_HOME",
        },
        trigger: { type: 'entry' }
    },
    {
        journeyName: "savings-transfer-out",
        cdfEvent: "SavingsFolderTransferOutStart",
        requiredParameters: {
            "cdf_action": "TransferOut",
            "origin": "SAVINGS_SUB_BALANCE",
        },
        trigger: { type: 'entry' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {},
        trigger: { type: 'entry' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "PROFILE_DIRECTORY",
        },
        trigger: { type: 'variant', variantName: 'discover' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "CUSTOMER_PROFILE_ACTIVITY",
        },
        trigger: { type: 'variant', variantName: 'customer-profile-activity' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "CUSTOMER_PROFILE_PROFILE_DIRECTORY",
        },
        trigger: { type: 'variant', variantName: 'customer-profile-discover' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "CUSTOMER_PROFILE_FAVORITES",
        },
        trigger: { type: 'variant', variantName: 'customer-profile-favorites' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "APP_LINK",
        },
        trigger: { type: 'variant', variantName: 'client-route' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "APP_SHORTCUT",
        },
        trigger: { type: 'variant', variantName: 'app-shortcut' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "SIRI_DRAFT_PAYMENT",
        },
        trigger: { type: 'variant', variantName: 'siri' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "AssetSendStart",
        requiredParameters: {
            "origin": "AMOUNT_FIRST",
        },
        trigger: { type: 'variant', variantName: 'amount-first' }
    },
    {
        journeyName: "send-money",
        cdfEvent: "CashSendCancel",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "StockTradeStart",
        requiredParameters: {
            "order_side": "BUY",
        },
        trigger: { type: 'entry' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockTradeStart",
        requiredParameters: {
            "order_side": "SELL",
        },
        trigger: { type: 'entry' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "StockTradeSubmitAmount",
        requiredParameters: {
            "order_side": "BUY",
            "order_type": "ONE_OFF",
        },
        trigger: { type: 'variant', variantName: 'one-off-buy' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "StockTradeSubmitAmount",
        requiredParameters: {
            "order_side": "BUY",
            "order_type": "AUTO_INVEST",
        },
        trigger: { type: 'variant', variantName: 'auto-invest' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "StockTradeSubmitAmount",
        requiredParameters: {
            "order_side": "BUY",
            "order_type": "CUSTOM",
        },
        trigger: { type: 'variant', variantName: 'custom-order' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockTradeSubmitAmount",
        requiredParameters: {
            "order_side": "SELL",
            "order_type": "ONE_OFF",
        },
        trigger: { type: 'variant', variantName: 'one-off-sale' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockTradeSubmitAmount",
        requiredParameters: {
            "order_side": "SELL",
            "order_type": "CUSTOM",
        },
        trigger: { type: 'variant', variantName: 'custom-order' }
    },
    {
        journeyName: "stock-buy",
        cdfEvent: "StockTradeExit",
        requiredParameters: {
            "order_side": "BUY",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "stock-sale",
        cdfEvent: "StockTradeExit",
        requiredParameters: {
            "order_side": "SELL",
        },
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "CashWithdrawStart",
        requiredParameters: {},
        trigger: { type: 'entry' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "CashWithdrawEnterAmount",
        requiredParameters: {
            "enter_method": "SELECTED",
        },
        trigger: { type: 'variant', variantName: 'Selected' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "CashWithdrawEnterAmount",
        requiredParameters: {
            "enter_method": "KEYPAD",
        },
        trigger: { type: 'variant', variantName: 'Keypad' }
    },
    {
        journeyName: "withdraw-money",
        cdfEvent: "CashWithdrawCancel",
        requiredParameters: {},
        trigger: { type: 'exit', outcome: 'userCanceled' }
    },
];
export var relevantEndpointsByJourneyName = {
    "add-money": [],
    "bitcoin-sell": [
        "/cash-app/crypto/invest/exchange",
    ],
    "identity-verification": [
        "/cash-app/device-attestation/validate-play-integrity-attestation",
        "/cash-app/device-attestation/validate-app-attest-attestation",
        "/cash-app/device-attestation/issue-challenge",
    ],
    "login": [
        "/cash-app/semaphore/get-onboarding-config",
        "/2.0/cash/initiate-session",
        "/cash-app/security/1.0/get-linked-accounts",
        "/cash-app/security/1.0/get-login-scenario-plan",
        "/2.0/cash/get-app-config",
        "/2.0/cash/get-profile",
    ],
    "open-the-app": [
        "/2.0/cash/check-version",
        "/2.0/cash/get-app-config",
        "/2.0/cash/get-scenario-plan",
        "/2.0/cash/initiate-session",
        "/cash-app/device-attestation/validate-app-attest-attestation",
        "/cash-app/device-attestation/validate-play-integrity-attestation",
        "/cash-app/onboarding/1.0/get-pre-sign-in-data",
        "/cash-app/security/1.0/get-login-scenario-plan",
        "/cash-app/semaphore/get-onboarding-config",
    ],
    "request-money": [
        "/cash-app/recipient-selector/search",
    ],
    "savings-transfer-in": [],
    "savings-transfer-out": [],
    "send-money": [
        "/cash-app/recipient-selector/search",
    ],
    "stock-buy": [],
    "stock-sale": [],
    "withdraw-money": [],
};
